import { InjectionToken } from '@angular/core';

import { ApplicationType } from '@kros-sk/models';

export const APPLICATION_TYPE_CONFIG = new InjectionToken<ApplicationType>('Application type config for auth module');

export const LOAD_FEATURE_FLAGS_IN_AUTH = new InjectionToken<boolean>('Load feature flags after auth success', {
  factory: (): boolean => true,
});
